import { LESSON_LOCK_CHANNEL } from "@plugins/common/service/lock.constant";

export interface LessonLockChannelMessage {
  action: string;
  resourceType: string;
  resourceUuid: string;
  lessonUuid: string | null;
  browserTabUuid: string;
}

export class LessonLockChannelClass {
  private readonly channel: BroadcastChannel;

  public constructor() {
    this.channel = new BroadcastChannel(LESSON_LOCK_CHANNEL);
  }

  public postMessage(message: LessonLockChannelMessage): void {
    this.channel.postMessage(message);
  }

  public onMessage(callback: (message: LessonLockChannelMessage) => void): void {
    this.channel.onmessage = (event: MessageEvent<LessonLockChannelMessage>) => {
      callback(event.data);
    };
  }

  public close(): void {
    this.channel.close();
  }
}
